// @ts-nocheck
(() => {
  const script = document.querySelector('script[src*="paypal-language"]');
  const language = script?.dataset.language;

  if (!language) return;

  const apply = () => {
    const el = document.getElementById('paypal-upstream-messaging-product');

    if (!el || el.querySelector('iframe')) return false;

    el.setAttribute('data-pp-language', language);
    return true;
  };

  if (apply()) return;

  const observer = new MutationObserver(() => {
    if (apply()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
